function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
//
import * as React from 'react';
import { color, StyleSheet, css } from "../../styles/theme";
var styles = StyleSheet.create({
  PartnerLogoContainer: {
    position: 'absolute',
    border: "1px solid ".concat(color.borderThemeDark),
    borderRadius: 3,
    zIndex: 1,
    backgroundColor: color.white
  },
  partnerLogo: {
    width: '100%',
    height: '100%',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }
});
export default function PartnerLogo(props) {
  var logoSrc = props.logoSrc;
  return /*#__PURE__*/React.createElement("span", _extends({}, css(styles.PartnerLogoContainer), {
    style: props.style
  }), logoSrc && /*#__PURE__*/React.createElement("div", _extends({}, css(styles.partnerLogo), {
    style: {
      backgroundImage: "url(".concat(logoSrc, ")")
    }
  })));
}